import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  MyHttpClientFactory,
  ResponseCasingEnum,
  environment,
} from '@ups/xplat/core';
import { Observable } from 'rxjs';
import { JobReadinessDto } from '@ups/xplat/api/dto';

const GET_JOB_READINESS = '/api/job-readiness/{:jobID}';

/**
 * Reads the job-readiness pre-flight result for a job (WI 30856). Read-only:
 * surfaces the red/green/warn setup-readiness so gaps show at entry time instead
 * of at export. The Sparta API scopes the caller to jobs they are granted, so an
 * out-of-scope or unknown job returns 404 (surfaced here as an error).
 */
@Injectable({ providedIn: 'root' })
export class JobReadinessService {
  private spartaClient: HttpClient;

  constructor(private clientFactory: MyHttpClientFactory) {
    this.spartaClient = this.clientFactory.createHttpClient(
      environment.urls.spartaAPI,
      true,
      ResponseCasingEnum.PascalCase
    );
  }

  public getJobReadiness(jobID: string): Observable<JobReadinessDto> {
    const url = GET_JOB_READINESS.split('{:jobID}').join(jobID);
    return this.spartaClient.get<JobReadinessDto>(url);
  }
}
